/** @module csi/widget/_svg/SnapToGrid */
define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"./_SnapGridDropDownPlugin",
	"./PluginFactory",
	"./util",
	"csi/locale"
], function(array,lang,_SnapGridDropDownPlugin,PluginFactory,util,locale) {

	return PluginFactory.declare([_SnapGridDropDownPlugin], {
		"class": "svgSelect csi-canvas-snap-grid",
		materialIcon: "grid_on",
		pluginName: "snapToGrid",
		title: "SnapToGrid",

		/**
		 * Create dropdown menu
		 */
		startup: function() {
			this.editor.isSnapToGuides = true;
			this.dropDown = this.snapGridDropDownMenu(["CanvasSnapToGrid","CanvasSnapToGuides"]);
			this.inherited(arguments);
		}
	});
});
